import React, { Suspense, useRef, useState, useEffect } from "react"
import { Canvas, useFrame, useLoader } from "@react-three/fiber"
import { ContactShadows, Environment, useGLTF, OrbitControls, PerspectiveCamera } from "@react-three/drei"
import { VRCanvas, Hands, useXR } from '@react-three/xr'
import { RGBMLoader } from "three-stdlib"
import * as THREE from 'three'
import { Stars } from './StarsVR'

useLoader.preload(RGBMLoader, ['Cube_denoised_encoded.png', 'Plane_denoised_encoded.png', 'Sphere_denoised_encoded.png'])
useGLTF.preload('untitled10.glb')


function Model(props) {
  const group = useRef()
  const [lightmap, lightmap1, lightmap2] = useLoader(RGBMLoader, ['Cube_denoised_encoded.png', 'Plane_denoised_encoded.png', 'Sphere_denoised_encoded.png'])
  const { nodes, materials } = useGLTF('untitled10.glb', './')
  
  lightmap.encoding = THREE.RGBM7Encoding;
  lightmap.flipY = false;
  const mat = new THREE.MeshBasicMaterial({ map: lightmap })

  lightmap1.encoding = THREE.RGBM7Encoding;
  lightmap1.flipY = false;
  const mat1 = new THREE.MeshBasicMaterial({map: lightmap1})

  lightmap2.encoding = THREE.RGBM7Encoding;
  lightmap2.flipY = false;
  const mat2 = new THREE.MeshBasicMaterial({map: lightmap2})

  // console.log('', lightmap.encoding)

  // const [lightmap1] = useLoader(RGBMLoader, ['Plane_denoised_encoded.png'])
 

  console.log(lightmap, lightmap1)
  // debugger;

  return (
    <group ref={group} {...props} dispose={null}>
      <mesh geometry={nodes.Cube.geometry} material={mat} />
      <mesh geometry={nodes.Plane.geometry} material={mat1} />
      <mesh
        geometry={nodes.Sphere.geometry}
        material={mat2}
        position={[0, 2.214, 0]}
      />
    </group>
  )
}

function Player(props) { 
  const { player, isPresenting } = useXR()

  useEffect(() => {
    if(isPresenting) {
      player.position.z += 5
    } else {
      player.position.z = 0
    }
  }, [isPresenting])

  return (
    <>
    <Hands />
    </>
  )
}

export default function App() {


  return (
    <>
      <VRCanvas dpr={[1, 1.5]} camera={{ position: [0, 1, 5], fov: 50 }}>
      <Stars />
        <Player />
        {/* <ambientLight intensity={0.01} /> */}
        {/* <spotLight intensity={0.01} angle={0.1} penumbra={1} position={[10, 15, 10]} castShadow /> */}
        <Suspense fallback={null}>
          
          <Model />
          {/* <Environment path="" files="potsdamer_platz_1k.hdr" /> */}
          {/* <ContactShadows rotation-x={Math.PI / 2} position={[0, -0.8, 0]} opacity={0.25} width={10} height={10} blur={1.5} far={0.8} /> */}
        </Suspense>
        <OrbitControls enableZoom={true} enablePan={false} />
      </VRCanvas>
    </>
  )
}
